import React from 'react';

import Typography from '@mui/material/Typography';

export const About = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        height: 800,
      }}
    >
      <div style={{ margin: '3em' }}>
        <Typography variant="h4" component="h4">
          About Us
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '1em',
          justifyContent: 'space-around',
          alignItems: 'center',
          width: '50em',
        }}
      >
        <div style={{ flex: 1 }}>
          <img src="./assets/about.png" height={500} />
        </div>
        <div
          style={{ flex: 1, width: '18em', textAlign: 'left', marginLeft: 40 }}
        >
          <Typography
            variant="h4"
            component="h4"
            style={{ marginBottom: '1em' }}
          >
            Your Worry Free
            <br /> Waitlist Service
          </Typography>
          <Typography style={{ marginBottom: '1em' }}>
            Retain, recoup and be reassured that your sold-out property will be
            100% occupied with more direct hotel bookings. When the inevitable
            last moment cancelations would normally cause revenue lost, our
            waitlist service will give you the peace of mind that a direct
            booking customer is waiting for and ready to directly book that now
            vacant room.
          </Typography>
          <Typography>
            RezyList bookings happen directly via your property website. With
            seamless integration, there’s really no reason not to give us a try!
          </Typography>
        </div>
      </div>
    </div>
  );
};
